import { useEffect, useState } from "react";
import Popup from "components/Popup/popup";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./Popup.module.css";
import "react-datepicker/dist/react-datepicker.css";
import { BookingList } from "modules/booking";
import { formatDate, profileStatusLabels } from "utils/bookingPopup";
import { GoInfo } from "react-icons/go";

interface BookingPopupProps {
  isOpen: boolean;
  onClose: () => void;
  bookinglist: BookingList;
}

export default function CancelDetailsPopup({ isOpen, onClose, bookinglist }: BookingPopupProps) {

  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const handleInfoOpen = () => setIsInfoOpen(true);
  const handleInfoClose = () => setIsInfoOpen(false);
  const handleClose = () => {
    onClose();
  };
  if (!isOpen) return null;

  return (
    <>

      <Popup
        title={`Stornierungfrage ${bookinglist.status}`}
        submitLabel={""}
        closeLabel={""}
        isWithButton={false}
        isOpen={isOpen}
        onClose={handleClose}
      >
        {isInfoOpen && (
          <Popup
            title={"Information zum Status"}
            submitLabel={""}
            closeLabel={""}
            isWithButton={false}
            isOpen={true}
            onClose={handleInfoClose}
          >
            <p>
              Die Maßnahmen beschränken sich nur auf die markierten Termine, wenn der Status "teilweise offen" oder "teilweise storniert" ist.
            </p>

          </Popup>
        )}
        <form>
          <div className={styles.form}>
            <div className={commonStyles.formGroupRow}>
              {bookinglist.recurrence == 'serial' ? (
                <>
                  <div className={commonStyles.formGroup}>
                    <label>von</label>
                    <p>{formatDate(bookinglist.date)}</p>
                  </div>
                  <div className={commonStyles.formGroup}>
                    <label>bis</label>
                    <p>{bookinglist.recurrence_date_3 ? formatDate(bookinglist.recurrence_date_3) : ''}</p>
                  </div>
                </>
              ) : (
                <div className={commonStyles.formGroup}>
                  <label>Datum</label>
                  <p>{formatDate(bookinglist.date)}</p>
                </div>
              )}
            </div>
            <div className={commonStyles.formGroupRow}>
              <div className={commonStyles.formGroup}>
                <label>Kind</label>
                <div className={commonStyles.formGroupRow}>
                  <div className={commonStyles.formGroupRow}>
                    <p>{bookinglist.name}</p>
                    <p>{bookinglist.age} Jahre</p>
                  </div>
                </div>
              </div>
              <div className={commonStyles.formGroup}>
                <label>Eltern Status</label>
                <div className={commonStyles.formGroupRow}>
                  <div className={styles.formGroupCountainer}>
                    <p>{profileStatusLabels[bookinglist.profile_status]}</p>
                  </div>

                </div>
              </div>

            </div>

            <div className={commonStyles.formGroupRow}>
              <div className={commonStyles.formGroup}>
                <label>Block</label>
                <div className={commonStyles.formGroupRow}>
                  <div className={styles.formGroupCountainer}>
                    <p>{bookinglist.block}</p>
                  </div>
                  <div className={styles.formGroupCountainer}>
                    <p> {bookinglist.recurrence == 'onetime' ? 'Einmalig' : 'Wöchentlich'}</p>
                  </div>
                </div>
              </div>
              <div className={commonStyles.formGroup}>
                <label>Kategorie</label>
                <div className={commonStyles.formGroupRow}>
                  <div className={styles.formGroupCountainer}>
                    <p>{bookinglist.category == 'care' ? 'Betreuung' : 'Eingewöhnung'}</p>
                  </div>
                </div>
              </div>
            </div>

            {bookinglist.recurrence == 'serial' && (
              <div>
                <label className={styles.label}>
                  Termine
                  {["teilweise offen", "teilweise storniert"].includes(bookinglist.status) && (
                    <GoInfo onClick={handleInfoOpen} />
                  )}
                </label>
                <div className={styles.chaeckBoxCountainer}>
                  <div className={styles.recurrenceCheckbox}>
                    <input
                      type="checkbox"
                      readOnly={true}
                      checked={['cancelledPending', 'cancelledConfirmed'].includes(bookinglist.recurrence_date_0_status ?? '')}
                    />
                    <span>
                      {bookinglist.recurrence_date_0?.toString()}
                    </span>
                  </div>
                  <div className={styles.recurrenceCheckbox}>
                    <input
                      type="checkbox"
                      readOnly={true}
                      checked={['cancelledPending', 'cancelledConfirmed'].includes(bookinglist.recurrence_date_1_status ?? '')}
                    />
                    <span>
                      {bookinglist.recurrence_date_1?.toString()}
                    </span>
                  </div>
                  <div className={styles.recurrenceCheckbox}>
                    <input
                      type="checkbox"
                      readOnly={true}
                      checked={['cancelledPending', 'cancelledConfirmed'].includes(bookinglist.recurrence_date_2_status ?? '')}
                    />
                    <span>
                      {bookinglist.recurrence_date_2?.toString()}
                    </span>
                  </div>
                  <div className={styles.recurrenceCheckbox}>
                    <input
                      readOnly={true}

                      type="checkbox"
                      checked={['cancelledPending', 'cancelledConfirmed'].includes(bookinglist.recurrence_date_3_status ?? '')}
                    />
                    <span>
                      {bookinglist.recurrence_date_3?.toString()}
                    </span>
                  </div>

                </div>
              </div>
            )}
            {bookinglist.note && <div className={commonStyles.formGroup}>
              <label>Bemerkung</label>
              <p> {bookinglist.note}</p>
            </div>}
            {bookinglist.feedback && <div className={commonStyles.formGroup}>
              <label>FeedBack</label>
              <p> {bookinglist.feedback}</p>
            </div>}
          </div>
        </form>
      </Popup >
    </>
  );
}

